import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import Errors from "./views/Errors";

import routes from "./routes";
import withTracker from "./withTracker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import { server } from "./config/server";

// window.onunload = () => {
//   // localStorage.clear();
//   alert("bye");
// };

export default () => (
  <Router>
    <div>
      <ToastContainer />
      {routes.map((route, index) => {
        return (
          <>
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={withTracker(props => {
                return (
                  <route.layout {...props}>
                    <route.component {...props} />
                  </route.layout>
                );
              })}
            />
            {/* <Route component={Errors} /> */}
            {/* <Redirect to="/404" /> */}
            {/* <Route path="*" component={NotFoundRoute} /> */}
          </>
        );
      })}
    </div>
  </Router>
);
